import React, { useState, useEffect } from 'react'
import { Modal, Input } from 'antd'
import { useTranslation } from 'react-i18next'

// Used for both creating a folder and renaming one (when `folder` is provided).
const CreateFolderModal = ({ visible, folder, onSubmit, onCancel, submitting = false }) => {
  const { t } = useTranslation()
  const isRename = !!folder
  const [name, setName] = useState('')

  useEffect(() => {
    if (visible) setName(folder ? folder.name : '')
  }, [visible, folder])

  const trimmed = name.trim()

  const handleOk = () => {
    if (!trimmed) return
    onSubmit(trimmed)
  }

  return (
    <Modal
      title={isRename ? t('Rename folder') : t('Create new folder')}
      visible={visible}
      okText={isRename ? t('Save') : t('Create folder')}
      cancelText={t('Cancel')}
      onOk={handleOk}
      onCancel={onCancel}
      confirmLoading={submitting}
      okButtonProps={{ disabled: !trimmed }}
      destroyOnClose
    >
      <div style={{ padding: 21 }}>
        <label style={{ display: 'block', marginBottom: 8 }}>{t('Folder name')}</label>
        <Input
          autoFocus
          value={name}
          placeholder={t('e.g. Summer Promo Banner')}
          onChange={(e) => setName(e.target.value)}
          onPressEnter={handleOk}
        />
      </div>
    </Modal>
  )
}

export default CreateFolderModal
